import React, { useState, useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { LimitTypeEnum } from 'src/model/limit'
import { userLimitsGetAction } from 'src/reducers/user-limits/action'
import { selectUserLimits } from 'src/reducers/user-limits/selector'

export const useAiState = () => {
  const dispatch = useDispatch()
  const userLimits = useSelector(selectUserLimits)
  const [aiState, setAiState] = useState({
    count: 0,
    limit: 0,
    loading: true,
    refreshedAt: null,
  })

  const setAiCount = useCallback(count => {
    setAiState(prev => ({ ...prev, count }))
  }, [])

  const handleLoading = useCallback(loading => {
    setAiState(prev => ({ ...prev, loading }))
  }, [])

  const fetchLimits = useCallback(() => {
    if (!userLimits) {
      dispatch(userLimitsGetAction())
    }
  }, [dispatch, userLimits])

  // Update aiState when userLimits changes
  const updateAiState = useCallback(() => {
    if (userLimits) {
      const aiData = userLimits.find(
        x => x.limit.type === LimitTypeEnum.AICourseCreation,
      )
      if (aiData) {
        setAiState({
          count: aiData.count,
          limit: aiData.limit.upperLimit,
          loading: false,
          refreshedAt: aiData.refreshedAt,
        })
      }
    }
  }, [userLimits])

  // Call updateAiState when userLimits changes
  useEffect(() => {
    updateAiState()
  }, [updateAiState])

  return { aiState, setAiCount, handleLoading, fetchLimits }
}
